export function timelineMonthLabel(key: string): string {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(key)) return 'Unknown date';
  // This formats a month label, not a conversion of the collected timestamp.
  return new Date(`${key}-01T12:00:00Z`).toLocaleDateString(undefined, {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function timelineCollectedLabel(value?: string | null): string {
  if (!value || !/^(?!0000)\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) return 'Unknown date';
  const date = new Date(value.replace(' ', 'T') + 'Z');
  if (
    !Number.isFinite(date.getTime()) ||
    date.toISOString().slice(0, 19).replace('T', ' ') !== value
  )
    return 'Unknown date';
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
